import { current, baseApi } from '../utils/api'

// 表格数据
export function getOrderData(data) {
  return current({
    url: '/biOrderBaseMid/orderPageList',
    method: 'post',
    data
  })
}

// 分公司列表
export function getCompany(params) {
  return current({
    url: `/biRole/getGwCompany/${params.sysId}`,
    method: 'get'
  })
}

// 分组列表
export function getGroup(data) {
  return current({
    url: '/biRole/getGwGroup',
    method: 'post',
    data
  })
}

// 顾问列表
export function getCounselor(data) {
  return current({
    url: '/biRole/getGw',
    method: 'post',
    data
  })
}

// 注册用户导出
export function exportOrderrdata(data) {
  return current({
    url: '/biOrderBaseMid/exportOrderBaseData',
    method: 'post',
    data,
    responseType: 'blob'
  })
}

// 费用明细表格数据
export function getCostPageList(data) {
  return current({
    url: '/biCostBaseMid/costPageList',
    method: 'post',
    data
  })
}

// 费用明细导出
export function exportCostBaseData(data) {
  return current({
    url: '/biCostBaseMid/exportCostBaseData',
    method: 'post',
    data
  })
}

// 修改订单类型

export function changeCustomerTypeNew(data) {
  return current({
    url: '/biOrderBaseMid/changeCustomerTypeNew',
    method: 'post',
    data
  })
}

// 订单分成

export function biOrderBaseMidshareOrder(data) {
  return current({
    url: '/biOrderBaseMid/shareOrder',
    method: 'post',
    data
  })
}

export const getUser = () => {
  return baseApi({
    url: '/sysuser/getAllUsers',
    method: 'get'
  })
}
